import MainPage from './MainPage';
import Jobs from './Jobs';
import TextPortfolio from './TextPortfolio';
import ProjectCard from './ProjectCard';

export default [
    {
        id: 0,
        component: MainPage,
    },
    {
        id: 1,
        component: TextPortfolio,
    },
    {
        id: 2,
        component: Jobs,
    },
    {
        id: 3,
        component: ProjectCard,
    },
];

